import ViolationsWidgets from './ViolationsWidgets';

export default ViolationsWidgets;
